/**
 * Returns a promise that resolves after `ms` milliseconds.
 *
 * Used across controladoria-v2 to enforce a minimum perceived loading duration
 * (see `MIN_PERCEIVED_LOADING_MS` in `constants/Status.js`) so spinners do not
 * flash on fast API responses. Centralised here to avoid duplicate inline
 * declarations.
 */
export const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

export default wait
